/**
 * Query-Keys des eigenen Workspace. Einstellungsseite und Anlage-Assistent teilen sie: eine
 * gespeicherte Änderung gilt sofort als Vorbelegung für das nächste neue Objekt. Nicht zu
 * verwechseln mit der Plattformliste aller Workspaces (`features/workspaces`).
 */
export const currentWorkspaceKeys = {
  workspace: ['current-workspace'] as const,
  settings: ['current-workspace', 'settings'] as const,
};
